import { Item, MenuItem } from "../../../../components/Menu";

import { LocalizationMessages } from "../../../../localization/messages";
import PropTypes from "prop-types";
import React from "react";
import { UISelectors } from "../../../../redux/selectors";
import { UrlUtils } from "../../../../utils";
import { useSelector } from "react-redux";

export const BlogMenuItem = ({ trackingInfo }) => {
  const links = useSelector(UISelectors.links);

  const blogItem = new Item({
    URL: UrlUtils.getNativeLink(links.blog),
    title: LocalizationMessages.blog,
    iconKey: "blog",
    target: "_blank"
  });

  return (
    <MenuItem
      item={blogItem}
      automationId="uc-blog"
      trackingInfo={trackingInfo}
      ignoreNavigation={true}
    />
  );
};

BlogMenuItem.propTypes = {
  trackingInfo: PropTypes.object
};
